<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y>
            <template v-slot:activator="{on,attrs}">
              <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              >
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
      
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="typeList"
                label="Type"
                v-model="queryParams.type"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="letterHeadList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
          <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.type }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
  
  <script>
import { shopService } from "../../services/shop-service";
import { letterHeadService } from "../../services/letter-head-service";

export default {
  name: "LetterHeadList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true,
      },
      {
        text: "Letter Head",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", sortable: false },
      { text: "Shop", align: "left", value: "shop.name" },
      { text: "Type", value: "type" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },

    shopList: [],
    letterHeadList: [],
    typeList: [{ label: "---ALL---", value: "" }],
    totalRows: 0,
    queryParams: {
      shopId: "",
      type: "",
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getLetterHeadList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.type) {
      this.queryParams.type = this.$route.query.type;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getShopList();
    this.getAllLetterHeadTypes();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "letter-heads", query: this.queryParams });
      this.getLetterHeadList();
    },
    onRegister() {
      this.$router.push("/letter-head/new");
    },
    onEdit(letterHead) {
      // go to details page
      this.$router.push("/letter-head/" + letterHead.id);
    },
    getLetterHeadList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      letterHeadService
        .getAllLetterHead(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.letterHeadList = res.data.letterHeadList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = { id: "", name: "---ALL---" };
          this.shopList.unshift(findAll);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getAllLetterHeadTypes() {
      letterHeadService
        .getAllLetterHeadTypes()
        .then((res) => {
          res.data.forEach((type) => {
            let tempObj = { label: type, value: type };
            this.typeList.push(tempObj);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
  